import React, { useState, useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const highlights = [
  { title: 'Full Kasko', val: 'Tam Güvence' },
  { title: 'Modern Filo', val: '2023+ Modeller' },
  { title: 'Destek', val: '7/24 Kesintisiz' }
];

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/services`)
      .then(res => res.json())
      .then(data => {
        setServices(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Hizmetler yüklenemedi:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', position: 'relative' }}>
      <Navbar />
      
      <main style={{ paddingTop: '160px' }}>
        {/* Header */}
        <section style={{ padding: '40px 0 60px', position: 'relative', overflow: 'hidden' }}>
          <div className="ambient-light" style={{ top: '-10%', right: '-10%', opacity: 0.15 }}></div>
          <div className="container">
            <div style={{ maxWidth: '800px' }}>
              <motion.h1 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: [0.23, 1, 0.32, 1] }}
                className="section-title"
              >
                Hizmet<span>Kültürümüz.</span>
              </motion.h1>
              <div style={{ height: '2px', width: '80px', background: 'var(--primary)', margin: '32px 0' }}></div>
              <p style={{ fontSize: '1.1rem', fontWeight: 300, lineHeight: 1.8, maxWidth: '600px', color: 'var(--text-muted)' }}>
                Erenis Otomotiv olarak sadece araç kiralamıyoruz, size kusursuz bir yolculuk deneyimi ve kişiselleştirilmiş otomotiv çözümleri sunuyoruz.
              </p>
            </div>
          </div>
        </section>

        {/* Service Grid */}
        <section style={{ padding: '40px 0 80px', position: 'relative' }}>
          <div className="ambient-light ambient-light-silver" style={{ bottom: '-20%', left: '-10%', opacity: 0.08 }}></div>
          <div className="container">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', border: '1px solid var(--card-border)', boxShadow: 'var(--shadow-lg)' }}>
              {loading ? (
                <div style={{ padding: '48px', color: 'var(--text-muted)' }}>Hizmetler yükleniyor...</div>
              ) : (
                services.map((service, i) => (
                  <motion.div 
                    key={service.id || i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1, duration: 0.8 }}
                    viewport={{ once: true }}
                    style={{ 
                      padding: '48px', 
                      borderBottom: '1px solid var(--card-border)', 
                      borderRight: '1px solid var(--card-border)',
                      transition: 'background 0.5s',
                      cursor: 'default'
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--card-hover-bg)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <div style={{ fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.4em', textTransform: 'uppercase', color: 'var(--primary)', marginBottom: '32px', opacity: 0.5 }}>
                      HİZMET {String(i + 1).padStart(2, '0')}
                    </div>
                    <h3 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '16px', color: 'var(--text-main)', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
                      {service.title}
                    </h3>
                    <p style={{ fontSize: '0.9rem', fontWeight: 300, lineHeight: 1.7, marginBottom: '28px', color: 'var(--text-muted)' }}>
                      {service.description}
                    </p>
                    <Link to="/teklif-al" style={{ fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--text-dim)', transition: 'color 0.3s' }}>
                      Teklif Talep Et —
                    </Link>
                  </motion.div>
                ))
              )}
            </div>
          </div>
        </section>

        {/* Highlights */}
        <section style={{ padding: '100px 0', position: 'relative', overflow: 'hidden' }}>
          <div className="container">
            <div className="grid lg:grid-cols-12 gap-20 items-center">
              <div className="lg:col-span-8">
                <h2 style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '-0.04em', color: 'var(--text-main)', lineHeight: 0.95 }}>
                  Farklı Bir <span style={{ color: 'var(--primary)', fontStyle: 'italic' }}>Standart.</span>
                </h2>
              </div>
              <div className="lg:col-span-4">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                  {highlights.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '1px solid var(--card-border)', paddingBottom: '16px' }}>
                      <span style={{ fontSize: '0.6rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.2em', color: 'var(--text-muted)' }}>{item.title}</span>
                      <span style={{ fontSize: '1.1rem', fontWeight: 900, color: 'var(--text-main)' }}>{item.val}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Services;
